const validateBackendUrl = () => {
  const backendUrl = import.meta.env.VITE_BACKEND_URL

  if (!backendUrl) {
    if (import.meta.env.DEV) {
      return null
    }
    throw new Error(
      'VITE_BACKEND_URL environment variable is required in production/staging environments. ' +
      'Please set it in your .env file or environment configuration.'
    )
  }

  try {
    new URL(backendUrl)
  } catch (error) {
    throw new Error(
      `Invalid VITE_BACKEND_URL format: "${backendUrl}". ` +
      'It must be a valid URL (e.g., https://api.example.com).'
    )
  }

  return backendUrl
}

export const getBackendUrl = () => {
  const backendUrl = validateBackendUrl()
  
  if (backendUrl === null) {
    return null
  }
  
  return backendUrl
}
